import { createFileRoute } from "@tanstack/react-router";

import { OnboardingProject } from "../../../features/onboarding/OnboardingProject";

export const Route = createFileRoute("/_app/onboarding/project")({
  component: OnboardingProject,
});
